import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [isScrolled, setIsScrolled] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const onOpen = () => setIsOpen(true);
  const onClose = () => setIsOpen(false);

  // Scroll davranışı - aşağı kaydırırken gizle, yukarı kaydırırken göster
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // Şeffaflık efekti için (tüm cihazlarda)
      setIsScrolled(currentScrollY > 20);

      // Mobilde menü gizleme davranışı (768px ve altı)
      if (window.innerWidth <= 768) {
        // Sayfanın en üstündeyse her zaman göster
        if (currentScrollY < 10) {
          setIsVisible(true);
        }
        // Aşağı kaydırıyorsa gizle
        else if (currentScrollY > lastScrollY && currentScrollY > 100) {
          setIsVisible(false);
        }
        // Yukarı kaydırıyorsa göster
        else if (currentScrollY < lastScrollY) {
          setIsVisible(true);
        }
      } else {
        // Desktop'ta her zaman görünür
        setIsVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    // Throttle için
    let ticking = false;
    const throttledHandleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    };

    // Resize event - ekran boyutu değiştiğinde kontrol et
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsVisible(true);
      }
    };

    window.addEventListener('scroll', throttledHandleScroll, { passive: true });
    window.addEventListener('resize', handleResize, { passive: true });

    // İlk yüklemede kontrol et
    handleScroll();

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, [lastScrollY]);

  // Menü açıkken body scroll'unu engelle
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add('menu-open');
      document.documentElement.classList.add('menu-open');
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
    } else {
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    }

    return () => {
      document.body.classList.remove('menu-open');
      document.documentElement.classList.remove('menu-open');
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
    };
  }, [isOpen]);

  return (
    <header
      className={`main-header ${isVisible ? 'header-visible' : 'header-hidden'}`}
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: isScrolled
          ? 'linear-gradient(to bottom, rgba(255,255,255,0.95) 0%, rgba(255,255,255,0.85) 100%)'
          : 'rgba(255, 255, 255, 0.15)',
        backdropFilter: isScrolled ? 'blur(12px)' : 'blur(8px)',
        WebkitBackdropFilter: isScrolled ? 'blur(12px)' : 'blur(8px)',
        boxShadow: isScrolled
          ? '0 8px 32px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.08)'
          : 'none',
        padding: 0,
        borderBottom: isScrolled ? '1px solid rgba(255,255,255,0.2)' : '1px solid rgba(255,255,255,0.05)',
        transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)'
      }}
    >
      <div
        style={{
          maxWidth: 1280,
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          height: 80,
          padding: '0 32px'
        }}
      >
        {/* Logo */}
        <Link to="/" style={{ textDecoration: 'none' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <div style={{
              width: 40,
              height: 40,
              borderRadius: 12,
              background: '#000',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 10px 20px rgba(0, 0, 0, 0.3)',
              overflow: 'hidden'
            }}>
              <img
                src="/qrmenu-small.webp"
                alt="QR Menu Logo"
                style={{
                  width: '100%',
                  height: '100%',
                  objectFit: 'contain'
                }}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0 }}>
              <span style={{
                fontSize: 24,
                fontWeight: 'bold',
                color: isScrolled ? '#000' : '#fff',
                transition: 'color 0.3s ease',
                textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
              }}>
                qrmenu.solutions
              </span>
              <span style={{
                fontSize: 12,
                color: isScrolled ? '#666' : 'rgba(255,255,255,0.8)',
                transition: 'color 0.3s ease'
              }}>Premium QR Çözümleri</span>
            </div>
          </div>
        </Link>

        {/* Desktop Navigation */}
        <nav className="desktop-nav" style={{ display: 'flex', gap: 32, alignItems: 'center' }}>
          <Link
            to="/"
            style={{
              color: isScrolled ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: 16,
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
            onMouseLeave={(e) => e.currentTarget.style.color = isScrolled ? '#000' : '#fff'}
          >
            Anasayfa
          </Link>
          <Link
            to="/hakkimizda"
            style={{
              color: isScrolled ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: 16,
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
            onMouseLeave={(e) => e.currentTarget.style.color = isScrolled ? '#000' : '#fff'}
          >
            Hakkımızda
          </Link>
          <Link
            to="/ozellikler"
            style={{
              color: isScrolled ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: 16,
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
            onMouseLeave={(e) => e.currentTarget.style.color = isScrolled ? '#000' : '#fff'}
          >
            Özellikler
          </Link>

          <Link
            to="/demo"
            style={{
              color: isScrolled ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: 16,
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
            onMouseLeave={(e) => e.currentTarget.style.color = isScrolled ? '#000' : '#fff'}
          >
            Demo
          </Link>
          <Link
            to="/iletisim"
            style={{
              color: isScrolled ? '#000' : '#fff',
              fontWeight: 600,
              fontSize: 16,
              textDecoration: 'none',
              transition: 'color 0.3s ease',
              textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
            }}
            onMouseEnter={(e) => e.currentTarget.style.color = '#d4af37'}
            onMouseLeave={(e) => e.currentTarget.style.color = isScrolled ? '#000' : '#fff'}
          >
            İletişim
          </Link>
        </nav>

        {/* Desktop Auth Button */}
        <Link
          className="desktop-auth-btn"
          to="/giris"
          style={{
            background: 'linear-gradient(135deg, #d4af37, #ffd700)',
            color: '#1A1A2E',
            fontWeight: 700,
            borderRadius: 8,
            padding: '12px 24px',
            fontSize: 16,
            textDecoration: 'none',
            boxShadow: '0 2px 8px rgba(212, 175, 55, 0.3)',
          }}
        >
          Giriş Yap
        </Link>

        {/* Mobile Menu Button */}
        <button
          className="mobile-menu-btn"
          style={{
            display: 'none',
            background: 'none',
            border: 'none',
            color: isScrolled ? '#000' : '#fff',
            fontSize: 24,
            cursor: 'pointer',
            padding: 8,
            transition: 'color 0.3s ease',
            textShadow: isScrolled ? 'none' : '0 2px 4px rgba(0,0,0,0.3)'
          }}
          onClick={onOpen}
        >
          ☰
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div
          className="mobile-menu-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            width: '100vw',
            height: '100vh',
            maxWidth: '100vw',
            maxHeight: '100vh',
            background: '#ffffff',
            zIndex: 10000,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            overflowY: 'auto',
            overflowX: 'hidden',
            WebkitOverflowScrolling: 'touch',
            margin: 0,
            padding: 0,
            boxSizing: 'border-box'
          }}
          onClick={(e) => {
            if (e.target === e.currentTarget) {
              onClose();
            }
          }}
        >
          {/* Header with logo and close button */}
          <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '16px 20px',
            borderBottom: '1px solid #e5e5e5',
            position: 'sticky',
            top: 0,
            background: '#ffffff',
            zIndex: 10001
          }}>
            {/* Logo Section */}
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 'clamp(12px, 3vw, 16px)',
              flex: 1
            }}>
              <div style={{
                width: 'clamp(40px, 10vw, 48px)',
                height: 'clamp(40px, 10vw, 48px)',
                borderRadius: 'clamp(12px, 3vw, 16px)',
                background: '#000',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden',
                flexShrink: 0
              }}>
                <img
                  src="/qrmenu-small.webp"
                  alt="QR Menu Logo"
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain'
                  }}
                />
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 0 }}>
                <span style={{
                  fontSize: 'clamp(18px, 4.5vw, 24px)',
                  fontWeight: 'bold',
                  color: '#000'
                }}>
                  qrmenu.solutions
                </span>
                <span style={{
                  fontSize: 'clamp(11px, 2.5vw, 14px)',
                  color: '#666'
                }}>
                  Premium QR Çözümleri
                </span>
              </div>
            </div>

            <button
              onClick={onClose}
              style={{
                fontSize: 'clamp(24px, 5vw, 32px)',
                background: 'none',
                border: 'none',
                color: '#000',
                cursor: 'pointer',
                padding: '8px',
                minWidth: '40px',
                minHeight: '40px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                lineHeight: 1,
                flexShrink: 0
              }}
              aria-label="Menüyü Kapat"
            >
              ✕
            </button>
          </div>

          {/* Menu Content */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            gap: 'clamp(24px, 5vw, 32px)',
            width: '100%',
            padding: 'clamp(24px, 6vw, 40px) clamp(20px, 5vw, 32px)',
            flex: 1
          }}>

            {/* Navigation Links */}
            <nav style={{
              display: 'flex',
              flexDirection: 'column',
              gap: 'clamp(12px, 3vw, 16px)',
              width: '100%'
            }}>
              <Link
                to="/"
                onClick={onClose}
                className="mobile-nav-link"
                style={{
                  textAlign: 'left',
                  fontSize: 'clamp(16px, 4vw, 20px)',
                  padding: 'clamp(12px, 3vw, 16px) 0',
                  color: '#000',
                  textDecoration: 'none',
                  fontWeight: 600,
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'color 0.2s ease'
                }}
              >
                Anasayfa
              </Link>
              <Link
                to="/hakkimizda"
                onClick={onClose}
                className="mobile-nav-link"
                style={{
                  textAlign: 'left',
                  fontSize: 'clamp(16px, 4vw, 20px)',
                  padding: 'clamp(12px, 3vw, 16px) 0',
                  color: '#000',
                  textDecoration: 'none',
                  fontWeight: 600,
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'color 0.2s ease'
                }}
              >
                Hakkımızda
              </Link>
              <Link
                to="/ozellikler"
                onClick={onClose}
                className="mobile-nav-link"
                style={{
                  textAlign: 'left',
                  fontSize: 'clamp(16px, 4vw, 20px)',
                  padding: 'clamp(12px, 3vw, 16px) 0',
                  color: '#000',
                  textDecoration: 'none',
                  fontWeight: 600,
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'color 0.2s ease'
                }}
              >
                Özellikler
              </Link>

              <Link
                to="/demo"
                onClick={onClose}
                className="mobile-nav-link"
                style={{
                  textAlign: 'left',
                  fontSize: 'clamp(16px, 4vw, 20px)',
                  padding: 'clamp(12px, 3vw, 16px) 0',
                  color: '#000',
                  textDecoration: 'none',
                  fontWeight: 600,
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'color 0.2s ease'
                }}
              >
                Demo
              </Link>
              <Link
                to="/iletisim"
                onClick={onClose}
                className="mobile-nav-link"
                style={{
                  textAlign: 'left',
                  fontSize: 'clamp(16px, 4vw, 20px)',
                  padding: 'clamp(12px, 3vw, 16px) 0',
                  color: '#000',
                  textDecoration: 'none',
                  fontWeight: 600,
                  borderBottom: '1px solid #f0f0f0',
                  transition: 'color 0.2s ease'
                }}
              >
                İletişim
              </Link>
            </nav>

            {/* Auth Button */}
            <div style={{
              borderTop: '1px solid #e5e5e5',
              paddingTop: 'clamp(20px, 5vw, 24px)',
              width: '100%',
              display: 'flex',
              flexDirection: 'column',
              gap: 'clamp(12px, 3vw, 16px)',
              marginTop: 'auto'
            }}>
              <Link
                to="/giris"
                onClick={onClose}
                style={{
                  background: 'linear-gradient(135deg, #d4af37, #ffd700)',
                  color: '#1A1A2E',
                  fontWeight: 700,
                  borderRadius: 'clamp(8px, 2vw, 12px)',
                  padding: 'clamp(14px, 3.5vw, 18px) clamp(20px, 5vw, 32px)',
                  fontSize: 'clamp(16px, 4vw, 18px)',
                  textDecoration: 'none',
                  textAlign: 'center',
                  boxShadow: '0 2px 8px rgba(212, 175, 55, 0.3)',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  display: 'block',
                  width: '100%'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-2px)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(212, 175, 55, 0.4)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 2px 8px rgba(212, 175, 55, 0.3)';
                }}
              >
                Giriş Yap
              </Link>
            </div>
          </div>
        </div>
      )}

      <style>
        {`
          @media (max-width: 768px) {
            .desktop-nav {
              display: none !important;
            }
            
            .desktop-auth-btn {
              display: none !important;
            }
            
            .mobile-menu-btn {
              display: block !important;
            }
            
            header > div {
              padding: 0 16px !important;
              height: 64px !important;
            }
            
            header > div > a > div > div:first-child {
              width: 32px !important;
              height: 32px !important;
            }
            
            header > div > a > div > div:last-child > span:first-child {
              font-size: 18px !important;
            }
            
            header > div > a > div > div:last-child > span:last-child {
              font-size: 10px !important;
            }
          }
          
          .mobile-menu-overlay {
            animation: slideInFromRight 0.3s ease-out;
            inset: 0 !important;
            position: fixed !important;
            width: 100vw !important;
            height: 100vh !important;
            max-width: 100vw !important;
            max-height: 100vh !important;
            margin: 0 !important;
            padding: 0 !important;
            box-sizing: border-box !important;
          }
          
          @keyframes slideInFromRight {
            from {
              transform: translateX(100%);
              opacity: 0;
            }
            to {
              transform: translateX(0);
              opacity: 1;
            }
          }
          
          .mobile-nav-link:hover {
            color: #d4af37 !important;
          }
          
          .mobile-nav-link:active {
            opacity: 0.7;
          }
          
          /* Menü açıkken body ve html scroll'unu engelle */
          body.menu-open {
            overflow: hidden !important;
            position: fixed !important;
            width: 100% !important;
            height: 100% !important;
          }
          
          html.menu-open {
            overflow: hidden !important;
            height: 100% !important;
          }
          
          /* Scroll davranışı - mobilde */
          @media (max-width: 768px) {
            .main-header {
              transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out !important;
            }
            
            .main-header.header-hidden {
              transform: translateY(-100%) !important;
              opacity: 0 !important;
            }
            
            .main-header.header-visible {
              transform: translateY(0) !important;
              opacity: 1 !important;
            }
          }
        `}
      </style>
    </header>
  );
};

export default Header;